import React, { useState } from "react";
import Image from "react-bootstrap/Image";
import { Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IMAGES } from "../../../assets/images/images";
import { Formik, Field, ErrorMessage, Form as FormikForm } from "formik";
import * as Yup from "yup";
import OtpInput from "react-otp-input";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { verifyForgotPassword } from "../../../utility/apiServices/userServices";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react";
// Validation schema
// const ResetPasswordSchema = Yup.object().shape({
//   otp: Yup.string().required("OTP is required"),
//   newpassword: Yup.string()
//     .min(8, "Password must be at least 8 characters")
//     .required("New Password is required"),
//   cnewpassword: Yup.string()
//     .oneOf([Yup.ref("newpassword"), null], "Passwords must match")
//     .required("Confirm New Password is required"),
// });

const PropertyOwnerResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location?.state?.email;
  const initialValues = { otp: "", newpassword: "", cnewpassword: "" };
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);


  const { t } = useTranslation();

  const ResetPasswordSchema = Yup.object().shape({
    otp: Yup.string().required(t("resetpassword.otp_required")),
    newpassword: Yup.string()
      .min(8, t("resetpassword.newpassword_min"))
      .required(t("resetpassword.newpassword_required")),
    cnewpassword: Yup.string()
      .oneOf([Yup.ref("newpassword"), null], t("resetpassword.passwords_match"))
      .required(t("resetpassword.cnewpassword_required")),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await verifyForgotPassword({
        email: email,
        otp: values.otp,
        newPassword: values.newpassword,
      });
      if (response.status) {
        Swal.fire({
          icon: "success",
          text: response.message || t("success_message"),
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/login");
          }
        });
      } else {
        Swal.fire({
          icon: "error",
          text: response.message || t("error_message"),
        });
      }
    } catch (error) {
      console.error("Form submission error: ", error);
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <section className="login_box">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-6 hideloginimg">
            <div className="login_bg">
              <Image src={IMAGES.Login_Bg} className="img-fluid" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="loginBody">
              <Formik
                initialValues={initialValues}
                validationSchema={ResetPasswordSchema}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting, values, setFieldValue }) => (
                  <FormikForm>
                    <h1>{t("resetpassword.title")}</h1>
                    <p className="para">{t("resetpassword.description")}</p>
                    <div className="mb-3">
                      <label htmlFor="otp" className="mb-1">{t("resetpassword.otp_label")}</label>
                      <div className="otpBox">
                        <OtpInput
                          value={values.otp}
                          onChange={(e) => setFieldValue("otp", e)}
                          numInputs={6}
                          // renderInput={(props) => <input {...props} />
                          renderInput={(props) => <input {...props} type="tel" inputMode="numeric" pattern="[0-9]*" />}

                        />
                      </div>
                      <ErrorMessage
                        name="otp"
                        component="div"
                        className="errorStyle"
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="newpassword">{t("resetpassword.newpassword_label")}</label>
                      <div className="position-relative">
                        <Field
                          type={showNewPassword ? "text" : "password"}
                          name="newpassword"
                          className="form-control mt-1"
                          placeholder={t("resetpassword.newpassword_placeholder")}
                        />
                        <button
                          type="button"
                          onClick={() => setShowNewPassword(!showNewPassword)}
                          className="password-toggle-btn"
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            padding: "5px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Icon
                            icon={showNewPassword ? "mdi:eye-off" : "mdi:eye"}
                            fontSize={20}
                            color="#666"
                          />
                        </button>
                      </div>
                      <ErrorMessage
                        name="newpassword"
                        component="div"
                        className="errorStyle"
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="cnewpassword">{t("resetpassword.cnewpassword_label")}</label>
                      <div className="position-relative">
                        <Field
                          type={showConfirmPassword ? "text" : "password"}
                          name="cnewpassword"
                          className="form-control mt-1"
                          placeholder={t("resetpassword.cnewpassword_placeholder")}
                        />
                        <button
                          type="button"
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          className="password-toggle-btn"
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            padding: "5px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Icon
                            icon={showConfirmPassword ? "mdi:eye-off" : "mdi:eye"}
                            fontSize={20}
                            color="#666"
                          />
                        </button>
                      </div>
                      <ErrorMessage
                        name="cnewpassword"
                        component="div"
                        className="errorStyle"
                      />
                    </div>
                    <Button
                      type="submit"
                      className="btn btn-primary my-3 mb-4 my-mb-3 mb-md-3 my-lg-3 w-100"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? t("resetpassword.submitting") : t("resetpassword.continue")}
                    </Button>

                    <p className="text-center">
                      {t("resetpassword.back_to")}{" "}
                      <Link to="/login" className="forgotPassword forgotPassword1">
                        {t("resetpassword.login")}
                      </Link>
                    </p>
                  </FormikForm>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PropertyOwnerResetPassword;
